





























import { Component, Prop, Vue } from "vue-property-decorator";
import { BPopover, BOverlay } from "bootstrap-vue";
import { AudioRecorder, getAudioRecorder } from "@/audio-recorder";
import { Timer } from "easytimer.js";

@Component({
  components: {
    BPopover,
    BOverlay,
  },
})
export default class AudioRecorderPopover extends Vue {
  id = "audio-recorder-popover";
  recorder: AudioRecorder | null = null;
  timer: Timer | null = null;
  timerValue = "00:00:00";
  get target() {
    return this.id + "-target";
  }
  save() {
    this.recorder?.stop();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  beforeDestroy() {
    this.timer?.stop();
  }
  async mounted() {
    // SET RECORDER
    this.recorder = await getAudioRecorder((data) => {
      this.$emit("save", data);
      this.close();
    });
    this.recorder.start();
    // SET TIMER
    this.timer = new Timer();
    this.timer.start();
    this.timer.addEventListener("secondsUpdated", (e) => {
      this.timerValue = this.timer?.getTimeValues().toString() || "00:00:00";
    });
    //
  }
}
